import { createSlice } from "@reduxjs/toolkit";
import { updateFieldReducer } from "@/redux/reducerHelpers";

const initialState = {
  autoRefresh: false,
  companyFilter: null, // { id, label } | null — null means "use role-derived default"
  providerFilter: null,
  filtersUserId: null, // userid whose filters these belong to (guard against cross-user leak)
  error: null,
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    updateAutoRefresh: (state, action) => updateFieldReducer(state, action, "autoRefresh"),
    updateCompanyFilter: (state, action) => {
      const value = action.payload?.companyFilter;
      if (value !== undefined) state.companyFilter = value;
    },
    updateProviderFilter: (state, action) => {
      const value = action.payload?.providerFilter;
      if (value !== undefined) state.providerFilter = value;
    },
    setFiltersOwner: (state, action) => {
      const value = action.payload?.filtersUserId;
      if (value !== undefined) state.filtersUserId = value;
    },
    resetDashboardFilters: (state) => {
      state.companyFilter = null;
      state.providerFilter = null;
      state.filtersUserId = null;
    },
  },
});

export const {
  updateAutoRefresh,
  updateCompanyFilter,
  updateProviderFilter,
  setFiltersOwner,
  resetDashboardFilters,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
